import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import Select from "react-select";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi,postDataApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const SignonHistory = () => {
  let emptyRow = {
    };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dialog, setDialog] = useState("");
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
    
    
  /* 
    const [defectType, setdefectType] = useState([]);
    const [defectConditiontype, setdefectConditiontype] = useState([]);
    const [commentsRequired, setCommentsRequired] = useState([]);
      
    const [defectTypeId, setdefectTypeId] = useState({label: "", value: null});
    const [defectTypeCode, setDefectTypeCode]=useState("");
    const [defectDescription, setDefectDescription]=useState("");
    const [defectConditionTypeId, setdefectConditionTypeId] = useState({label: "", value: null});  
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();  
    const [commentsRequiredId, setCommentsRequiredId] = useState({label: "", value: ""});    
    const [sortKey, setSortKey] = useState(null);
  
    const [defectTypeSelectId, setDefectTypeSelectId] = useState({label: "", value: null});
    const [defectConditiontypeSelectId, setDefectConditiontypeSelectId] = useState({label: "", value: null});   
    const [commentsRequiredSelectFlagId, setCommentsRequiredSelectFlagId] = useState({label: "", value: ""});
    
/////////////////////////////////////////////////////////////////////////// */
const [fetchTabletName, setFetchTabletName] = useState(true);
    const [fetchActiveType, setFetchActiveType] = useState(true);
    const [fetchProdLine, setFetchProdLine] = useState(true);
    const [fetchShiftNumber, setFetchShiftNumber] = useState(true);
    const [fetchLotNumber, setFetchLotNumber] = useState(true);
    const [fetchMgTypeName, setFetchMgTypeName] = useState(true);
    
    
    
  
    const [tabletName, setTabletName] = useState([]);
    const [activeType, setActiveType] = useState([]);
    const [prodLine, setProdLine] = useState([]);
    const [shiftNumber, setShiftNumber] = useState([]);
    const [lotNumber, setLotNumber] = useState([]);
    const [mgType, setMgType] = useState([]);
    const [mgName, setMgName] = useState([]);
      
    const [userName, setUserName]=useState(""); 
    const [tabletNameId, setTabletNameId] = useState({label: "", value: null});  
    const [activeTypeId, setActiveTypeId] = useState({label: "", value: ""});  
    const [prodLineId, setProdLineId] = useState({label: "", value: null});
    const [shiftNumberId, setShiftNumberId] = useState({label: "", value: null});        
    const [lotNumberId, setLotNumberId] = useState({label: "", value: null});
    const [mgTypeId, setMgTypeId] = useState({label: "", value: ""});  
    const [mgNameId, setMgNameId] = useState({label: "", value: ""});
    const [creationFromDate, setCreationFromDate] = useState();
    const [creationDate, setCreationDate] = useState();
    const [shiftDate, setShiftDate] = useState();  
    const [nextCursor, setNextCursor] = useState(null);
    const [hasMore, setHasMore] = useState(false);

const toast = useRef(null);
  const dt = useRef(null);
  //////////////////////////////////////////////////////////////////////
useEffect(() => {
                        
                  const fetchMgTypeName = async () => {
                    setFetchMgTypeName(true);
                    try {
                      let res = await postDataApi("/api/setup/system/signonHistory/mgTypeNameLov");
                      if (res) {
                        let successFlag = res.data[0];
                        console.log("mgTypeName Lov: ",res);
                        console.log("Success Flag",successFlag);
                        if (successFlag === "Y" && Array.isArray(res.data[1])) {
                          const options_1= res.data[1].map((item)=>({
                            label: item.machine_group_type,
                            value: item.machine_group_type
                          }))
                          setMgType(options_1);
                          
                          const options_2= res.data[1].map((item)=>({
                            label: item.machine_group_name,
                            value: item.machine_group_name
                          }))
                          setMgName(options_2);

                          setFetchMgTypeName(false);
                        } 
                      }
                    } catch (err) {
                      console.log(err);
                      setFetchMgTypeName(false);
                    }
                  };
                  fetchMgTypeName();
                }, []);

useEffect(() => {
                        
                  const fetchLotNumber = async () => {
                    setFetchLotNumber(true);
                    try {
                      let res = await postDataApi("/api/setup/system/signonHistory/lotNumberLov");
                      if (res) {
                        let successFlag = res.data[0];
                        console.log("Lot Number Lov: ",res);
                        console.log("Success Flag",successFlag);
                        if (successFlag === "Y" && Array.isArray(res.data[1])) {
                          const options= res.data[1].map((item)=>({
                            label: item.lot_number,
                            value: item.shift_lot_id
                          }))
                          setLotNumber(options);
                          setFetchLotNumber(false);
                        } 
                      }
                    } catch (err) {
                      console.log(err);
                      setFetchLotNumber(false);
                    }
                  };
                  fetchLotNumber();
                }, []);

useEffect(() => {
                        
                  const fetchShiftNumber = async () => {
                    setFetchShiftNumber(true);
                    try {
                      let res = await postDataApi("/api/setup/system/signonHistory/shiftNumberLov");
                      if (res) {
                        let successFlag = res.data[0];
                        console.log("ShiftNumber Lov: ",res);
                        console.log("Success Flag",successFlag);
                        if (successFlag === "Y" && Array.isArray(res.data[1])) {
                          const options= res.data[1].map((item)=>({
                            label: item.shift_number,
                            value: item.shift_number
                          }))
                          setShiftNumber(options);
                          setFetchShiftNumber(false);
                        } 
                      }
                    } catch (err) {
                      console.log(err);
                      setFetchShiftNumber(false);
                    }
                  };
                  fetchShiftNumber();
                }, []);
  
      useEffect(() => {
                      const fetchTabletName = async () => {
                        setFetchTabletName(true);
                        try {
                          let res = await getDataApi("/api/setup/system/tabletMG/tabletNameLOV");
                          if (res) {
                            let successFlag = res.data[0];
                            console.log("Tablet Name Lov: ",res);
                            console.log("Success Flag",successFlag);
                            if (successFlag === "Y" && Array.isArray(res.data[1])) {
                              const options= res.data[1].map((item)=>({
                                label:item. tablet_name,
                                value:item.tablet_id
                              }))
                              setTabletName(options)
                              setFetchTabletName(false);
                            } 
                          }
                        } catch (err) {
                          console.log(err);
                          setFetchTabletName(false);
                        }
                      };
                      fetchTabletName();
                    }, []);
     
                    
 useEffect(() => {
                   const fetchActiveType = async () => {
                     setFetchActiveType(true);
                     try {
                       let res = await postDataApi("/api/setup/system/signonHistory/activityTypeLov");
                       if (res) {
                         let successFlag = res.data[0];
                         console.log("Active type Lov: ",res);
                         console.log("Success Flag",successFlag);
                         if (successFlag === "Y" && Array.isArray(res.data[1])) {
                           const options= res.data[1].map((item)=>({
                             label: item.signon_activity_type,
                             value: item.signon_activity_type
                           }))
                           setActiveType(options)
                           setFetchActiveType(false);
                         } 
                       }
                     } catch (err) {
                       console.log(err);
                       setFetchActiveType(false);
                     }
                   };
                   fetchActiveType();
                 }, []);
 useEffect(() => {
                         
                   const fetchProdLine = async () => {
                     setFetchProdLine(true);
                     try {
                       let res = await postDataApi("/api/setup/system/signonHistory/prodLineLov");
                       if (res) {
                         let successFlag = res.data[0];
                         console.log("ProdLine Lov: ",res);
                         console.log("Success Flag",successFlag);
                         if (successFlag === "Y" && Array.isArray(res.data[1])) {
                           const options= res.data[1].map((item)=>({
                             label: item.production_line_number,
                             value: item.production_line_number
                           }))
                           setProdLine(options);
                           setFetchProdLine(false);
                         } 
                       }
                     } catch (err) {
                       console.log(err);
                       setFetchProdLine(false);
                     }
                   };
                   fetchProdLine();
                 }, []);
       
 
                    
     





  //////////////////////////////////////////////////////////////////////////

  
  
     


   
//correctly working api
const handleLoadData = async () => {

    const pageSize = 500;

    // FIRST PAGE ALWAYS STARTS WITH NULL
    const cursorId = null;

    const p_param = {
        p_user_name: userName,
        p_tablet_name: tabletNameId.label,
        p_creation_from_date: creationFromDate,
        p_creation_date: creationDate,
        p_signon_activity_type: activeTypeId.label,
        p_machine_group_type: mgTypeId.label,
        p_machine_group_name: mgNameId.label,
        p_production_line_number: prodLineId.value,
        p_shift_date: shiftDate,
        p_shift_number: shiftNumberId.value,
        p_shift_lot_id: lotNumberId.value,

        p_page_size: pageSize,
        p_cursor_id: cursorId
    };

    console.log("FIRST PAGE REQUEST:", p_param);

    try {

        setIsLoading(true);

        const response = await loadApi(p_param, "/api/setup/system/signonHistory/selRows"
        );

        console.log("API RESPONSE:", response);
        console.log("API DATA:", response.data);

        const apiData = response.data;

        if (apiData.successFlag === "Y") {

            const fetchedRows = apiData.data || [];

            console.log("Fetched rows:", fetchedRows.length);           
            setRows(fetchedRows);             
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);          
            setNextCursor(apiData.nextCursor);            
            setHasMore(apiData.hasMore);

            console.log(
                "Next Cursor:",
                apiData.nextCursor
            );

            console.log(
                "Has More:",
                apiData.hasMore
            );

            if (fetchedRows.length > 0) {

                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Data fetched successfully"
                });

                setWasDataFetchingSuccessful(false);

            } else {

                setRows([]);
                setNextCursor(null);
                setHasMore(false);
                setWasDataFetchingSuccessful(false);
            }

        } else {

            setRows([]);
            setNextCursor(null);
            setHasMore(false);

            const errorInfo =
                apiData.message || "Error fetching data";

            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
            setWasDataFetchingSuccessful(true);
        }

    } catch (error) {

        if (
            axios.isCancel(error) ||
            error.name === "CanceledError"
        ) {

            console.log(
                "Request was cancelled by the user."
            );

            toast.current.show({
                severity: "warn",
                summary: "Cancelled",
                detail: "Request successfully cancelled by the user.",
                life: 3000
            });

        } else {

            console.error(
                "Error On Fetching Signon History:",
                error
            );
        }

    } finally {

        setIsLoading(false);
    }
};

const handleLoadMore = async () => {


		if (!hasMore || nextCursor === null) {
		console.log("No more data available.");
		return; 
		}

    const pageSize = 500;
	const cursorId = nextCursor;

    

    const p_param = {
        p_user_name: userName,
        p_tablet_name: tabletNameId.label,        
        p_creation_from_date: creationFromDate,
        p_creation_date: creationDate,
        p_signon_activity_type: activeTypeId.label,
        p_machine_group_type: mgTypeId.label,
        p_machine_group_name: mgNameId.label,
        p_production_line_number: prodLineId.value,
        p_shift_date: shiftDate,
        p_shift_number: shiftNumberId.value,
        p_shift_lot_id: lotNumberId.value,

        p_page_size: pageSize,
        p_cursor_id: cursorId
    };

    console.log("LOAD MORE REQUEST:", p_param);

    try {

        setIsLoading(true);

        const response = await loadApi(
            p_param,
            "/api/setup/system/signonHistory/selRows"
        );

        console.log("LOAD MORE RESPONSE:", response);
        console.log("API DATA:", response.data);

        const apiData = response.data;

        if (apiData.successFlag === "Y") {

            const newRows = apiData.data || [];

            console.log( "New rows:", newRows.length );

            
            setRows(prevRows => [ ...prevRows, ...newRows ]);

            // IMPORTANT:
            // Save next cursor returned by Node
			
            setNextCursor(apiData.nextCursor);

            // Save whether another page exists
            setHasMore(apiData.hasMore);

            console.log(
                "Next Cursor:",
                apiData.nextCursor
            );

            console.log(
                "Has More:",
                apiData.hasMore
            );

            if (newRows.length > 0) {

                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Data fetched successfully"
                });

                setWasDataFetchingSuccessful(false);

            } else {

                setRows([]);
                setNextCursor(null);
                setHasMore(false);
                setWasDataFetchingSuccessful(true);
            }

        } else {

            setRows([]);
            setNextCursor(null);
            setHasMore(false);

            const errorInfo =
                apiData.message || "Error fetching data";

            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
            setWasDataFetchingSuccessful(true);
        }

    } catch (error) {

        if (
            axios.isCancel(error) ||
            error.name === "CanceledError"
        ) {

            console.log(
                "Request was cancelled by the user."
            );

            toast.current.show({
                severity: "warn",
                summary: "Cancelled",
                detail: "Request successfully cancelled by the user.",
                life: 3000
            });

        } else {

            console.error(
                "Error On Fetching Signon History:",
                error
            );
        }

    } finally {

        setIsLoading(false);
    }
};




  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };
  
  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setDialog("")
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const activityDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.creation_date);
  };

  const shiftDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.shift_date);
  };
 const aDate = row.creation_date ? moment.utc(row.creation_date).format("DD-MMM-YYYY") : null;
 const pDate = row.shift_date ? moment.utc(row.shift_date).format("DD-MMM-YYYY") : null;

 
  /* onst findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].defect_code_id === id) {
        index = i;
        break;
      }
    }
    return index;
  }; */

  const exportCSV = () => {
    dt.current.exportCSV();
  };


     
          

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Inquire-Signon History</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        Inquire-Signon History
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          {/* <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span> */}
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };





  const onInputNumberChange = (e, name) => {
    const val = (e.target.valueAsNumber) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };


  const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span>
      </div>
      <div>
       {/*  <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        /> */}
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );



 
  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["Sort Key : "];
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }
  
  const inputRightBoxStyle = {
    textAlign: "right",
     outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`
  }
  //////////////////////////////////////////////////////////////////////////
const handleTabletNameId = (selectedOption) => {
    if(selectedOption == null) {
      setTabletNameId({label: "", value: null});
    } else {
    setTabletNameId(selectedOption);
    }
  };

  const handleActiveTypeId = (selectedOption) => {
    if(selectedOption == null) {
      setActiveTypeId({label: "", value: ""});
    } else {
    setActiveTypeId(selectedOption);
    }
  };

  const handleProdLineId = (selectedOption) => {
    if(selectedOption == null) {
      setProdLineId({label:"", value: null});
    } else {
    setProdLineId(selectedOption);
    console.log(prodLineId)
    }
  };

  const handleShiftNumberId = (selectedOption) => {
    if(selectedOption == null) {
      setShiftNumberId({label: "", value: null});
    } else {
    setShiftNumberId(selectedOption);
    console.log(shiftNumberId)
    }
  };

 const handleLotNumberId = (selectedOption) => {
    if(selectedOption == null) {
      setLotNumberId({label: "", value: null});
    } else {
    setLotNumberId(selectedOption);
    console.log(lotNumberId)
    }
  };

  const  handleMgTypeId = (selectedOption) => {
    if(selectedOption == null) {
      setMgTypeId({label: "", value: ""});
    } else {
    setMgTypeId(selectedOption);
    console.log(mgTypeId)
    }
  };
const handleMgNameId = (selectedOption) => {
    if(selectedOption == null) {
      setMgNameId({label: "", value: ""});
    } else {
    setMgNameId(selectedOption);
    console.log(mgNameId)
    }
  };

const handleActivityFromDateChange = (e) => {
          setCreationFromDate(e.target.value);
        };

const handleActivityDateChange = (e) => {
          setCreationDate(e.target.value);
        };

const handleProdDateChange = (e) => {
          setShiftDate(e.target.value);
        };


  //////////////////////////////////////////////////////////////////////////
const getTabletNameControl = () => (
              <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Tablet  Name</label>
               <Select
                  id="TabletNameId"
                  name="TabletNameId"
                  onChange={handleTabletNameId}
                  options={tabletName}
                  value={tabletNameId}
                  placeholder="Select Tablet Name"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown"
                  classNamePrefix="select-dropdown"
                   menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
                />
            </div>
          </React.Fragment>
            );
const getActiveTypeControl = () => (
          <React.Fragment>
        <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
          <label className="form-label">Activity Type</label>
           <Select
              // className="form-select"
              id="activityTypeTypeId"
              name="activityTypeName"
              onChange={handleActiveTypeId}
              options={activeType}
              value={activeTypeId}
              placeholder="Select Activity type"
              isSearchable={true}
              isClearable={true}
              isDisabled={isLoading}
              className="select-dropdown"
              classNamePrefix="select-dropdown"
                   menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
            />
        </div>
      </React.Fragment>
        );
    const getUserNameControl = () => (
                <React.Fragment>
                  <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">User Name</label>
                        <InputText 
                        type="text"
                        id = "usernameid"
                        name="usernameid" 
                        onChange={(e) => setUserName(e.target.value)}
                        placeholder="Enter Defect Type Code"
                        disabled={isLoading}
                        className="input-outline" />
                         </div>
                </React.Fragment>
              ); 
const getProdLineControl = () => (
              <React.Fragment>
                <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">Line#</label>
                 <Select
                  // className="form-select"
                  id="ProdLineId"
                  name="ProdLineIdName"
                  onChange={handleProdLineId}                  
                  options={prodLine}
                  value={prodLineId}
                  placeholder="Line No."
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown1"
                  classNamePrefix="select-dropdown1"
                  menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
                />
                </div>
              </React.Fragment>
            );
const getShiftNumberControl = () => (
              <React.Fragment>
                <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">Shift Number</label>
                 <Select
                  // className="form-select"
                  id="shiftNumberId"
                  name="shiftNumberIdName"
                  onChange={handleShiftNumberId}                  
                  options={shiftNumber}
                  value={shiftNumberId}
                  placeholder="Shift Number"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown1"
                  classNamePrefix="select-dropdown1"
                  menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
                />
                </div>
              </React.Fragment>
            );

            const getLotnumberControl = () => (
              <React.Fragment>
                <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">Lot#</label>
                 <Select
                  // className="form-select"
                  id="lotNumberId"
                  name="lotNumberIdName"
                  onChange={handleLotNumberId}                  
                  options={lotNumber}
                  value={lotNumberId}
                  placeholder="Enter Lot"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown1"
                  classNamePrefix="select-dropdown1"
                  menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
                />
                </div>
              </React.Fragment>
            );

const getMgTypeControl = () => (
              <React.Fragment>
                <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">Machine Group Type</label>
                 <Select
                  // className="form-select"
                  id="mgTypeId"
                  name="mgTypeIdName"
                  onChange={handleMgTypeId}
                  options={mgType}
                  value={mgTypeId}
                  placeholder="Machine Group Type"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown1"
                  classNamePrefix="select-dropdown1"
                  menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
                />
                </div>
              </React.Fragment>
            );
 const getMgNameControl = () => (
              <React.Fragment>
                <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
                  <label className="form-label">Machine Group Name</label>
                 <Select
                  // className="form-select"
                  id="mgNameId"
                  name="mgNameIdName"
                  onChange={handleMgNameId}
                  options={mgName}                 
                  value={mgNameId}
                  placeholder="Machine Group Name"
                  isSearchable={true}
                  isClearable={true}
                  isDisabled={isLoading}
                  className="select-dropdown1"
                  classNamePrefix="select-dropdown1"
                  menuPortalTarget={document.body}
            styles={{menuPortal: (base) => 
            ({...base,zIndex: 9999,}),menu: (base) => ({...base, zIndex: 9999,}),}}
          
                />
                </div>
              </React.Fragment>
            );
const getProdDateControl = () => (
          <React.Fragment>
            
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Prod Date</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="prodDateid"
                name="prodDateName"
                value={shiftDate}
                onChange={handleProdDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
          </React.Fragment>
        );
const getActivityDateControl = () => (
          <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Activity From Date</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="ActivityDateid"
                name="ActivityDatename"
                value={creationFromDate}
                onChange={handleActivityFromDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Activity To Date</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="ActivityDateid"
                name="ActivityDatename"
                value={creationDate}
                onChange={handleActivityDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            
          </React.Fragment>
        );
   

     const getGoButtonControl = () => (
        <React.Fragment>
          <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0 gap-2" style={{paddingTop:'1.9375rem'}}>
            <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadData}
              disabled={isLoading}
            >              
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Go"}</span>
            </button>

            {hasMore && (
                <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadMore}
              disabled={isLoading}
            >              
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Load More"}</span>
            </button>
                    )}
            
          </div>
        </React.Fragment>
      );

      const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }
  return (
    <div>
      <Toast ref={toast} />
    <div className="col mx-2">
        {fetchTabletName && fetchActiveType  ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!fetchTabletName && !fetchActiveType  && (
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              
              {getUserNameControl()}
              {getTabletNameControl()}
              {getActivityDateControl()}
              {getActiveTypeControl()}
              {getMgTypeControl()}
              {getMgNameControl()}
              {getProdLineControl()}              
              {getProdDateControl()}
              {getShiftNumberControl()}
              {getLotnumberControl()}
              {getGoButtonControl()}
             
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Inquire NonWork Type</div> */}
            <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="shift_signon_detail_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Machine"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No Signon History Data Found"
              stripedRows
              showGridlines        
              responsiveLayout="scroll"
              rowExpansion
            >
                                        <Column
                                          body={readBodyTemplate}
                                          exportable={false}
                                          style={{ width: "0.75rem" }}
                                        ></Column>
                                        <Column
                                          field="shift_signon_detail_id"
                                          header="id"
                                          sortable="false"
                                          hidden="true"
                                          exportable={false}
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="shift_date"
                                          header="Pro Date"
                                          body={shiftDateBodyTemplate}
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="creation_date"
                                          header="Activity Date"
                                          body={activityDateBodyTemplate}
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="signon_activity_type"
                                          header="Activity Type"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="machine_group_type"
                                          header="Machine Group Type"                                       
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="machine_group_name"
                                          header="Machine Group Name"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="production_line_number"
                                          header="Line#"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="shift_number"
                                          header="Shift#"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="tablet_name"
                                          header="Tablet Name"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                        <Column
                                          field="user_name"
                                          header="User Name"
                                          sortable
                                          style={{ whiteSpace: "nowrap" }}
                                        ></Column>
                                                                                                                        
            </DataTable>
          </div>
        )}
        </div>
        </div>
        )}
       


        <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                                <h4 style={{"fontWeight":"bold"}}> Signon History Details </h4>
                                <Divider className="my-4" />
                                <h5 style={{"fontWeight":"bold"}}> View Signon History </h5>
                                <Divider className="my-4" />
                                <div className="card-wrapper">
                                  <CardComponent
                                    title="Signon History Details  "
                                    data={[{label:"Prod Date : ", value:pDate },
                                      {label:"Activity Date : ", value:aDate },
                                      {label:"Activity Type : ", value: row.signon_activity_type},
                                      {label:"Machine Group Type : ", value: row.machine_group_type},
                                      {label:"Machine Group Name : ", value: row.machine_group_name},
                                    ]}
                                  />
                                  <CardComponent
                                    title="Line & Shift Details"
                                    data={[                                      
                                      {label:"Line# : ", value: row.production_line_number},
                                      {label:"Shift# : ", value: row.shift_number},
                                      {label:"Tablet Name : ", value: row.tablet_name},
                                      {label:"User Name : ", value: row.user_name},
                                    ]}
                                  />
                                 </div>
                            </Dialog>
          
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(2,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default SignonHistory;
